'use strict';

require('../xdr/index.js');
require('@noble/hashes/sha2.js');
require('uint8array-extras');
require('../base/signing.js');
require('../base/keypair.js');
require('@exodus/bytes/base32.js');
require('../base/util/continued_fraction.js');
require('../base/util/bignumber.js');
require('../base/muxed_account.js');
var sorobandata_builder = require('../base/sorobandata_builder.js');
var contract = require('../base/contract.js');
require('@stellar/js-xdr');
var api = require('./api.js');
var diagnosticEvent = require('../xdr/generated/diagnostic-event.js');
var ledgerEntryData = require('../xdr/generated/ledger-entry-data.js');
var transactionMeta = require('../xdr/generated/transaction-meta.js');
var transactionEvent = require('../xdr/generated/transaction-event.js');
var contractEvent = require('../xdr/generated/contract-event.js');
var transactionResult = require('../xdr/generated/transaction-result.js');
var ledgerHeader = require('../xdr/generated/ledger-header.js');
var ledgerCloseMeta = require('../xdr/generated/ledger-close-meta.js');
var ledgerHeaderHistoryEntry = require('../xdr/generated/ledger-header-history-entry.js');
var ledgerEntry = require('../xdr/generated/ledger-entry.js');
var scVal = require('../xdr/generated/sc-val.js');
var ledgerKey = require('../xdr/generated/ledger-key.js');
var transactionEnvelope = require('../xdr/generated/transaction-envelope.js');
var sorobanAuthorizationEntry = require('../xdr/generated/soroban-authorization-entry.js');

function parseRawSendTransaction(raw) {
  const { errorResultXdr, diagnosticEventsXdr } = raw;
  delete raw.errorResultXdr;
  delete raw.diagnosticEventsXdr;
  if (errorResultXdr) {
    return {
      ...raw,
      ...diagnosticEventsXdr !== void 0 && diagnosticEventsXdr.length > 0 && {
        diagnosticEvents: diagnosticEventsXdr.map(
          (evt) => diagnosticEvent.DiagnosticEvent.fromXdr(evt, "base64")
        )
      },
      errorResult: transactionResult.TransactionResult.fromXdr(errorResultXdr, "base64")
    };
  }
  return { ...raw };
}
function parseTransactionInfo(raw) {
  const meta = transactionMeta.TransactionMeta.fromXdr(raw.resultMetaXdr, "base64");
  const info = {
    ledger: raw.ledger,
    createdAt: raw.createdAt,
    applicationOrder: raw.applicationOrder,
    feeBump: raw.feeBump,
    envelopeXdr: transactionEnvelope.TransactionEnvelope.fromXdr(raw.envelopeXdr, "base64"),
    resultXdr: transactionResult.TransactionResult.fromXdr(raw.resultXdr, "base64"),
    resultMetaXdr: meta,
    events: {
      contractEventsXdr: (raw.events?.contractEventsXdr ?? []).map(
        (lst) => lst.map((e) => contractEvent.ContractEvent.fromXdr(e, "base64"))
      ),
      transactionEventsXdr: (raw.events?.transactionEventsXdr ?? []).map(
        (e) => transactionEvent.TransactionEvent.fromXdr(e, "base64")
      )
    }
  };
  switch (meta.type) {
    case "v3":
    case "v4": {
      const metaV = meta.value;
      if (metaV.sorobanMeta !== null) {
        info.returnValue = metaV.sorobanMeta.returnValue ?? void 0;
      }
    }
  }
  if (raw.diagnosticEventsXdr) {
    info.diagnosticEventsXdr = raw.diagnosticEventsXdr.map(
      (e) => diagnosticEvent.DiagnosticEvent.fromXdr(e, "base64")
    );
  }
  return info;
}
function parseRawTransactions(r) {
  return {
    status: r.status,
    txHash: r.txHash,
    ...parseTransactionInfo(r)
  };
}
function parseRawEvents(raw) {
  return {
    latestLedger: raw.latestLedger,
    oldestLedger: raw.oldestLedger,
    latestLedgerCloseTime: raw.latestLedgerCloseTime,
    oldestLedgerCloseTime: raw.oldestLedgerCloseTime,
    cursor: raw.cursor,
    events: (raw.events ?? []).map((evt) => {
      const clone = { ...evt };
      delete clone.contractId;
      return {
        ...clone,
        ...evt.contractId !== "" && {
          contractId: new contract.Contract(evt.contractId)
        },
        topic: (evt.topic ?? []).map((topic) => scVal.ScVal.fromXdr(topic, "base64")),
        value: scVal.ScVal.fromXdr(evt.value, "base64")
      };
    })
  };
}
function parseRawLedgerEntries(raw) {
  return {
    latestLedger: raw.latestLedger,
    entries: (raw.entries ?? []).map((rawEntry) => {
      if (!rawEntry.key || !rawEntry.xdr) {
        throw new TypeError(
          `invalid ledger entry: ${JSON.stringify(rawEntry)}`
        );
      }
      return {
        lastModifiedLedgerSeq: rawEntry.lastModifiedLedgerSeq,
        key: ledgerKey.LedgerKey.fromXdr(rawEntry.key, "base64"),
        val: ledgerEntryData.LedgerEntryData.fromXdr(rawEntry.xdr, "base64"),
        ...rawEntry.liveUntilLedgerSeq !== void 0 && {
          liveUntilLedgerSeq: rawEntry.liveUntilLedgerSeq
        }
      };
    })
  };
}
function parseSuccessful(sim, partial) {
  const success = {
    ...partial,
    transactionData: new sorobandata_builder.SorobanDataBuilder(sim.transactionData),
    minResourceFee: sim.minResourceFee,
    // coalesce 0-or-1-element results[] list into a single result struct
    // with decoded fields if present
    ...(sim.results?.length ?? 0) > 0 && {
      result: sim.results.map((row) => ({
        auth: (row.auth ?? []).map(
          (entry) => sorobanAuthorizationEntry.SorobanAuthorizationEntry.fromXdr(entry, "base64")
        ),
        // if return value is missing ("falsy") we coalesce to void
        retval: row.xdr ? scVal.ScVal.fromXdr(row.xdr, "base64") : scVal.ScVal.scvVoid()
      }))[0]
    },
    ...(sim.stateChanges?.length ?? 0) > 0 && {
      stateChanges: sim.stateChanges?.map((entryChange) => ({
        type: entryChange.type,
        key: ledgerKey.LedgerKey.fromXdr(entryChange.key, "base64"),
        before: entryChange.before ? ledgerEntry.LedgerEntry.fromXdr(entryChange.before, "base64") : null,
        after: entryChange.after ? ledgerEntry.LedgerEntry.fromXdr(entryChange.after, "base64") : null
      }))
    }
  };
  if (!sim.restorePreamble || sim.restorePreamble.transactionData === "") {
    return success;
  }
  return {
    ...success,
    restorePreamble: {
      minResourceFee: sim.restorePreamble.minResourceFee,
      transactionData: new sorobandata_builder.SorobanDataBuilder(
        sim.restorePreamble.transactionData
      )
    }
  };
}
function parseRawSimulation(sim) {
  const looksRaw = api.Api.isSimulationRaw(sim);
  if (!looksRaw) {
    return sim;
  }
  const base = {
    _parsed: true,
    id: sim.id,
    latestLedger: sim.latestLedger,
    events: sim.events?.map((evt) => diagnosticEvent.DiagnosticEvent.fromXdr(evt, "base64")) ?? []
  };
  if (typeof sim.error === "string") {
    return {
      ...base,
      error: sim.error
    };
  }
  return parseSuccessful(sim, base);
}
function parseRawLedger(raw) {
  if (!raw.metadataXdr || !raw.headerXdr) {
    let missingFields;
    if (!raw.metadataXdr && !raw.headerXdr) {
      missingFields = "metadataXdr and headerXdr";
    } else if (!raw.metadataXdr) {
      missingFields = "metadataXdr";
    } else {
      missingFields = "headerXdr";
    }
    throw new TypeError(`invalid ledger missing fields: ${missingFields}`);
  }
  const metadataXdr = ledgerCloseMeta.LedgerCloseMeta.fromXdr(raw.metadataXdr, "base64");
  const headerXdr = ledgerHeaderHistoryEntry.LedgerHeaderHistoryEntry.fromXdr(raw.headerXdr, "base64");
  return {
    hash: raw.hash,
    sequence: raw.sequence,
    ledgerCloseTime: raw.ledgerCloseTime,
    metadataXdr,
    headerXdr
  };
}
function parseRawLatestLedger(raw) {
  const headerXdr = ledgerHeader.LedgerHeader.fromXdr(raw.headerXdr, "base64");
  const metadataXdr = ledgerCloseMeta.LedgerCloseMeta.fromXdr(raw.metadataXdr, "base64");
  let missingFields;
  if (!raw.metadataXdr && !raw.headerXdr) {
    missingFields = "metadataXdr and headerXdr";
  } else if (!raw.metadataXdr) {
    missingFields = "metadataXdr";
  } else if (!raw.headerXdr) {
    missingFields = "headerXdr";
  }
  if (missingFields) {
    throw new TypeError(
      `invalid getLatestLedger response missing fields: ${missingFields}`
    );
  }
  return {
    id: raw.id,
    sequence: raw.sequence,
    protocolVersion: raw.protocolVersion,
    closeTime: raw.closeTime,
    headerXdr,
    metadataXdr
  };
}

exports.parseRawEvents = parseRawEvents;
exports.parseRawLatestLedger = parseRawLatestLedger;
exports.parseRawLedger = parseRawLedger;
exports.parseRawLedgerEntries = parseRawLedgerEntries;
exports.parseRawSendTransaction = parseRawSendTransaction;
exports.parseRawSimulation = parseRawSimulation;
exports.parseRawTransactions = parseRawTransactions;
exports.parseTransactionInfo = parseTransactionInfo;
//# sourceMappingURL=parsers.js.map
